import { Renderer2, inject } from "@angular/core";

export type Script = {
	location: "head" | "body";
	content?: string;
	src?: string;
};

export class ScriptInjector {
	private readonly _renderer = inject(Renderer2);

	public inject(...scripts: Script[]): void {
		for (const script of scripts) {
			this._inject(script);
		}
	}

	private _inject(script: Script): void {
		const element = this._renderer.createElement("script");
		element.type = "text/javascript";
		const { head, body } = document;
		const { location, content, src } = script;
		const target = location === "head" ? head : body;
		if (src) {
			element.src = src;
		} else if (content) {
			element.textContent = content;
		}
		this._renderer.appendChild(target, element);
	}
}
